import React from "react";
import "./SmallSidebar.css";
import { Grid, Drawer } from "@mui/material";
import Logo from "../../../assets/images/StyLogo.png";
import Navlinks from "../Navlinks";

const SmallSidebar = ({ showSideBar, toggleSidebar }) => {
  return (
    <Drawer
      anchor="left"
      open={showSideBar}
      onClose={toggleSidebar}
      className="smallDialog"
      sx={{
        "@media (min-width: 992px)": {
          display: "none",
        },
      }}
      PaperProps={{
        sx: {
          width: "260px",
          backgroundColor: "white",
          padding: "1rem",
        }
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <span
          onClick={toggleSidebar}
          style={{
            cursor: "pointer",
            paddingRight: "0.5rem",
            fontWeight: "bold",
          }}
        >
          X
        </span>
      </div>
      <div style={{ padding: "2rem" }}>
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{ height: "55px", width: "200px" }}
          />
        </header>
        <Navlinks toggleSidebar={toggleSidebar} />
      </div>
    </Drawer>
  );
};

export default SmallSidebar;
